import { forwardRef, type SVGProps } from 'react';

export type FigmaCaretDownIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const FigmaCaretDownIcon = forwardRef<SVGSVGElement, FigmaCaretDownIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path d="M8 10L11 6L5 6L8 10Z" fill="currentColor" />
  </svg>
));

FigmaCaretDownIcon.displayName = 'FigmaCaretDownIcon';
